/** Normalise un numéro burkinabè : 8 chiffres locaux (ex. 70077299) */
export function normalizeBurkinaPhone(phone) {
  if (!phone) return '';
  let digits = String(phone).replace(/\D+/g, '');

  if (digits.startsWith('00226')) {
    digits = digits.slice(5);
  } else if (digits.startsWith('226') && digits.length > 8) {
    digits = digits.slice(3);
  }

  if (digits.length > 8) {
    digits = digits.slice(-8);
  }

  return digits;
}

/** Mobile BF : 8 chiffres commençant par 5, 6 ou 7 */
export function isValidBurkinaPhone(phone) {
  const normalized = normalizeBurkinaPhone(phone);
  return /^[567]\d{7}$/.test(normalized);
}

export const BURKINA_PHONE_HINT = '8 chiffres, ex. 70077299';
export const BURKINA_PHONE_ERROR = 'Numéro invalide. Format attendu : 8 chiffres (ex. 70077299)';

export const burkinaPhoneRule = {
  validate: (value) => {
    if (!value || !String(value).trim()) return true;
    return isValidBurkinaPhone(value) || BURKINA_PHONE_ERROR;
  },
};
